import {StyleSheet} from "aphrodite";

import {CARD_HEIGHT} from "./constants.ts";

// Easing functions
const EASE_OUT = "cubic-bezier(.165, .84, .44, 1)"; //  EASE_OUT_QUART

// keyframes
const accepting = {
    "0%": {
        opacity: 1,
        transform: "translate(0px, 0px)",
    },
    "60%": {
        opacity: 1,
    },
    "100%": {
        opacity: 0,
        transform: "translate(60px, 16px) rotate(3deg)",
    },
};

const discarding = {
    "0%": {
        opacity: 1,
        transform: "translate(0px, 0px)",
    },
    "60%": {
        opacity: 1,
    },
    "100%": {
        opacity: 0,
        transform: "translate(-64px, -24px) rotate(-3deg)",
    },
};

const fadingIn = {
    "0%": {
        opacity: 0,
    },
    "100%": {
        opacity: 1,
    },
};

const fadingOut = {
    "0%": {
        opacity: 1,
    },
    "100%": {
        opacity: 0,
    },
};

const slidingUp = {
    from: {
        transform: "translate(0, 0)",
    },
    to: {
        transform: "translateX(-8px) translateY(-8px)",
    },
};

// Keyframes
const slidingIn = {
    "0%": {
        opacity: 0,
        transform: "translate(-24px, -24px)",
        height: 50,
    },
    "100%": {
        opacity: 1,
        transform: "translate(0px, 0px)",
        height: CARD_HEIGHT,
    },
};

const styles = StyleSheet.create({
    accepting: {
        opacity: 1,
        // @ts-expect-error work around missing @keyframes support
        animationName: accepting,
        animationDuration: "0.3s",
        animationTimingFunction: "ease-in",
        animationFillMode: "forwards",
    },
    discarding: {
        opacity: 1,
        // @ts-expect-error work around missing @keyframes support
        animationName: discarding,
        animationDuration: "0.4s",
        animationTimingFunction: "ease-in",
        animationFillMode: "forwards",
    },
    fadingIn: {
        opacity: 0,
        // @ts-expect-error work around missing @keyframes support
        animationName: [slidingUp, fadingIn],
        animationDuration: "0.4s",
        animationTimingFunction: "ease-in",
        animationFillMode: "forwards",
    },
    fadingOut: {
        // @ts-expect-error work around missing @keyframes support
        animationName: fadingOut,
        animationDuration: "0.4s",
        animationTimingFunction: "ease-in",
        animationFillMode: "forwards",
    },
    slidingUp: {
        // @ts-expect-error work around missing @keyframes support
        animationName: slidingUp,
        animationDuration: "0.4s",
        animationTimingFunction: "ease-in",
        animationFillMode: "forwards",
    },
    slidingIn: {
        opacity: 0,
        // @ts-expect-error work around @keyframes support
        animationName: slidingIn,
        animationDuration: "0.8s",
        animationFillMode: "forwards",
        animationTimingFunction: EASE_OUT,
    },
});

export default styles;
